import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const tagVariants = cva("tag", {
  variants: {
    variant: {
      success: "tag--success",
      info: "tag--info",
      warning: "tag--warning",
      danger: "tag--danger",
      ai: "tag--ai",
    },
    size: {
      sm: "tag--sm",
      md: "tag--md",
      lg: "tag--lg",
    },
    rounded: {
      true: "tag--rounded",
    },
    linkable: {
      true: "tag--linkable",
    },
    dismissable: {
      true: "tag--dismissable",
    },
  },
})

interface TagProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tagVariants> {}

function Tag({
  className,
  variant,
  size,
  rounded,
  linkable,
  dismissable,
  ...props
}: TagProps) {
  return (
    <span
      className={cn(
        tagVariants({ variant, size, rounded, linkable, dismissable }),
        className,
      )}
      {...props}
    />
  )
}

function TagLabel({
  className,
  ...props
}: {
  className?: string
  children?: React.ReactNode
  [key: string]: any
}) {
  return <span className={cn("tag__label", className)} {...props} />
}

function TagLiveIcon() {
  return <span className="tag__live-dot" />
}

function TagIcon({
  className,
  ...props
}: {
  className?: string
  children?: React.ReactNode
  [key: string]: any
}) {
  return <span className={cn("tag__icon", className)} {...props} />
}

export { Tag, TagLabel, TagLiveIcon, TagIcon, tagVariants }
export type { TagProps }

